export default __webpack_public_path__ + "static/media/hub_active.0826bf74.svg";